const stepperData = [
  "内容入力",
  "対象施設一覧確認・異動状況登録",
  "入力内容確認",
  "機構へ提出",
];

const infoManual1 = `施設の処理状況欄に「未登録」「登録中」が存在する場合は、「登録」ボタンを押して、職員の異動状況を登録してください。<
すべての施設の処理状況欄が「登録済み」になっていることを確認し、画面下部にある「次へ」ボタンを押してください。<`;

const infoManual2 = `すべての施設の処理状況列が「登録済み」になっていることを確認後、「次へ」ボタンを押してください。`;

const infoHeadTitleList: any[] = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "処理状況",
  },
  {
    headTitle: "職員の異動状況",
    className: "SCRC050107TableButtonClomun",
    dontNeedSort: true,
  },
];

const contextText = `入力された経営者でなくなった年月日の翌日以降の退職(予定)年月日・異動情報(配置換え)が入力されている職員が存在します。
このまま契約解除の申請を進めると、退職(予定)年月日・異動情報(配置換え)が削除されますがよろしいですか。`;

export {
  stepperData,
  infoManual1,
  infoManual2,
  infoHeadTitleList,
  contextText,
};
